import $ from 'jquery'
import { resultsRowTemplate } from './results-row-template'
import { updateQueryStringParameter } from '../../shared/url'
import algoliaFilter from '../../molecules/search/algolia-filters'
//import algoliaSortBy from '../../molecules/search/algolia-sort-by'

/**
 * Algolia Instant Search v2 implementation
 *
 * Docs: https://community.algolia.com/instantsearch.js/v2/guides/usage.html
 */
export default function instantSearch () {
  const container = document.querySelector('.js-search')

  if (!container) {
    return
  }

  const tableHeader = container.querySelector('.js-search-table-header')
  const controls = container.querySelector('.js-search-controls')
  const resultsContainer = container.querySelector('.js-search-results')
  const pagination = container.querySelector('.js-search-pagination')

  // State
  let initialLoading = true

  /**
   * Checks with a class if the current state of the page is in the Results page.
   * @returns {boolean} is it in the Results page?
   */
  function isAllResultsPage () {
    return container.className.replace(/[\n\t]/g, ' ').indexOf(container.dataset['allResultsCssClass']) !== -1
  }
  const initialQuery = new URL(window.location.href).searchParams.get('s')
  resultsContainer.innerHTML = ''

  const search = window.instantsearch({
    appId: container.dataset.algoliaAppId,
    apiKey: container.dataset.algoliaApiReadKey,
    indexName: 'wp_searchable_posts',
    searchFunction (helper) {
      helper.search()
    },
    searchParameters: {
      query: initialQuery
    }
  })

  // initialize SearchBox
  search.addWidget(
    window.instantsearch.widgets.searchBox({
      container: '#algolia-search-box',
      placeholder: 'Search',
      magnifier: false,
      reset: false
    })
  )

  /**
   * Custom widget for the "sort by" section.
   */
  /*search.addWidget({
    init: function onWidgetInit (opts) {
      algoliaSortBy(opts)
    }
  })

  search.addWidget(
    window.instantsearch.widgets.sortBySelector({
      container: '.js-search-sort-by--mobile',
      indices: [
        {name: 'wp_searchable_posts', label: 'Sort by Relevance'},
        {name: 'wp_searchable_posts_time_desc', label: 'Sort by Time'}
      ]
    })
  )*/

  /**
   * Results widget.
   */
  search.addWidget(
    window.instantsearch.widgets.hits({
      container: '#algolia-hits',
      templates: {
        empty: 'No results found',
        item: resultsRowTemplate
      },
      transformData: {
        item: function transformData (item) {
          if (item.post_tags) {
            item.tags = item.post_tags.map(tag => `<a href="${tag.url}">${tag.name}</a>`).join(' ')
          }
          return item
        }
      },
      transformItems: items => {
        if (items.length === 0) {
          clearSearchPage()
        } else {
          if (isAllResultsPage()) {
            pagination.style.display = 'block'
          }
          activateResultsElements()
        }

        return items.map(item => item)
      }
    })
  )

  /**
   * Pagination widget.
   */
  search.addWidget(
    window.instantsearch.widgets.pagination({
      container: '#algolia-pagination',
      maxPages: 20
    })
  )

  /**
   * Filters widgets.
   */
  //search.addWidget(algoliaFilter('tax_thesis', 'thesis', 'Thesis'))
  search.addWidget(algoliaFilter('tax_idea', 'idea', 'Idea: All'))
  search.addWidget(algoliaFilter('post_author.display_name', 'author', 'Author: All'))
  search.addWidget(algoliaFilter('post_tags.name', 'tag', 'Tags: All'))
  //search.addWidget(algoliaFilter('tax_company', 'company', 'Company'))

  /**
   * This functionality is triggered when the Widgets are rendered.
   *
   * - Update URL with search input text.
   * - Initialize Selectric
   */
  search.addWidget({
    render: function initWidget (renderOptions) {
      const $inputText = $('#algolia-search-box input')
      const parsedUrl = new URL(window.location.href)
      const initialQuery = parsedUrl.searchParams.get('s')

      hidePagination(renderOptions.results.nbPages)

      if (initialLoading) {
        if (initialQuery) {
          $inputText.val(initialQuery)
        } else {
          clearSearchPage()
        }
        initialLoading = false
      } else {
        const newURL = updateQueryStringParameter(window.location.href, 's', $inputText.val())
        window.history.pushState('', '', newURL)
        if ($inputText.val() == "") {
          clearSearchPage()
        }
      }
    }
  })

  search.start()


  /**
   * Hides the pagination when the the number of pages is equal to 1.
   * @param {int} numberPages number of result pages.
   */
  function hidePagination(numberPages) {
    if (numberPages === 1) {
      pagination.style.display = 'none'
    } else {
      pagination.style.display = 'block'
    }
  }

  /**
   * Activate DOM elements that show the Results page.
   */
  function activateResultsElements () {
    if (isAllResultsPage()) {
      controls.style.display = 'flex'

      if (window.innerWidth >= 992) {
        tableHeader.style.display = 'flex'
      }
    }
  }

  /**
   * Hides the elements for setting the Search Page as a new search.
   */
  function clearSearchPage () {
    resultsContainer.innerHTML = ''
    controls.style.display = 'none'
    tableHeader.style.display = 'none'
    pagination.style.display = 'none'
  }
}
